import { render, staticRenderFns } from "./TestimonialItem3Template.vue?vue&type=template&id=e70e1f86"
import script from "./TestimonialItem3Template.vue?vue&type=script&lang=js"
export * from "./TestimonialItem3Template.vue?vue&type=script&lang=js"
import style0 from "./TestimonialItem3Template.vue?vue&type=style&index=0&id=e70e1f86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports